import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TdDayComponent } from "./td-day.component";
import { MatTableModule } from "@angular/material/table";
import { TravelDateModule } from 'libraries/component/travel-date/travel-date.module';
import { DatePipeModule } from "libraries/date/date.module";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        TravelDateModule,
        DatePipeModule,
    ],
    exports: [
        TdDayComponent,
    ],
    declarations: [
        TdDayComponent,
    ],
})
export class TdDayModule {
}
